import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const ITEM_DELETE_REASONS = [
  "Wrong item added",
  "Quantity entered incorrectly",
  "Item unavailable / out of stock",
  "Customer changed item",
  "Duplicate item added",
  "Kitchen rejected item",
  "Other",
];

function OrderItemDeleteConfirmDialog({ open, onClose, onConfirmDelete }) {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  useEffect(() => {
    if (!open) {
      setReason("");
      setCustomReason("");
    }
  }, [open]);

  const handleConfirm = () => {
    const finalReason = reason === "Other" ? customReason : reason;
    onConfirmDelete(finalReason);
  };

  const isDisabled = !reason || (reason === "Other" && !customReason.trim());

  return (
    <Dialog
      open={open}
      onClose={(e, r) => {
        if (r !== "backdropClick") onClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Delete Item</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please select a reason for deleting this item.
        </Typography>

        <TextField
          select
          fullWidth
          label="Delete Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          margin="normal"
        >
          {ITEM_DELETE_REASONS.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>

        {reason === "Other" && (
          <TextField
            fullWidth
            label="Enter custom reason"
            value={customReason}
            onChange={(e) => setCustomReason(e.target.value)}
            margin="normal"
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Back
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isDisabled}
        >
          Delete Item
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OrderItemDeleteConfirmDialog;
